import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'tw-middleware-client',
    templateUrl: './middleware-client.component.html',
    styleUrls: ['./middleware-client.component.css'],
    standalone: true
})
export class MiddlewareClientComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
